var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"transform":"translate(1 1)","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"stroke":"#888888","width":"24","height":"24","rx":"12"}}),_c('path',{attrs:{"d":"M12.769 7.882V6.089H11.16v1.793h1.609zm0 11.118V9.63H11.16V19h1.609z","fill":"#3B3A3A","fill-rule":"nonzero","opacity":".811"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }